<template>
  <path
    d="M3.70004 9.11024L11.29 16.7002C11.68 17.0902 12.31 17.0902 12.7 16.7002L19 10.4002V14.0002C19 14.5502 19.45 15.0002 20 15.0002C20.55 15.0002 21 14.5502 21 14.0002V8.00024C21 7.45024 20.55 7.00024 20 7.00024H14C13.45 7.00024 13 7.45024 13 8.00024C13 8.55024 13.45 9.00024 14 9.00024H17.59L12 14.5902L5.11004 7.70024C4.72004 7.31024 4.09004 7.31024 3.70004 7.70024C3.32004 8.09024 3.32004 8.73024 3.70004 9.11024Z"
  />
</template>
